<div class="main-header">
  <div *ngIf="noIcon" class="icon-area">
    <mat-icon id="arrow-back" (click)="toPreviousPage()">arrow_back</mat-icon>
  </div>
  <div class="text-area"><ng-content ></ng-content></div>
</div>
